// @ts-nocheck

// App
import { useDispatch, useSelector } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

// Icons
import IconArrowFilled from 'images/icons/arrow-filled-white.min.svg';

// Tracking

// Misc / utils
import queryUtils from 'app/shared/utils/queryUtils';
import VALUE_CONSTANTS from 'app/shared/constants/ValueConstants';
import * as S from './styles';

const NextPageLink = () => {
  // Redux
  const dispatch = useDispatch();
  const pathname = useSelector((state) => state.location.current.pathname);
  const query = useSelector((state) => state.location.current.query);
  const maxBuildings = useSelector((state) => state.listings.totalBuildings);

  const hasPageParam = query.page && Boolean(query.page);
  const newQuery = Object.assign({}, query, { page: 2 });
  const newPageLink = pathname + queryUtils.stringify(newQuery);
  const maxPage = Math.max(Math.ceil(maxBuildings / VALUE_CONSTANTS.MAX_LISTINGS_PER_PAGE), 1);

  const yieldTrackingAndTransitionTo = useYieldCallback(() => {
    window.router.transitionTo(newPageLink);
  });

  const handleButtonClick = (e) => {
    // Prevent the browser from going through with its default <a> behavior
    e.preventDefault();

    yieldTrackingAndTransitionTo();
  };

  if ((hasPageParam && query.page > 1) || maxPage === 1) {
    return null;
  }

  return (
    <S.FlexSection>
      <S.NextPage
        tabIndex={0}
        aria-label={'Next page of search results'}
        linkType={null}
        to={newPageLink}
        onClick={handleButtonClick}
      >
        Next page of search results
        <S.ArrowIcon src={IconArrowFilled} height="12px" width="12px" alt="" />
      </S.NextPage>
    </S.FlexSection>
  );
};

export default NextPageLink;
